<template>

  <div class="szll_h5">
    <TopTabs :list="this.$nav22"/>
    <ul class="tsnn_bottom" v-if="list.length>0">
      <li v-for="(item, index) in list"
          :key="item.id"
          @click="toPage(item)"
          :class="(index + 1) % 3 == 0 ? 'no_margin':''">
          <img
            class="teacher_img"
            :src="item.photo_url"
          />
          <div class="tsnn_title" v-if="item.name !== ''">{{item.name}}</div>
      </li>
    </ul>
    <div v-else>&nbsp;&nbsp;暂无数据</div>
  </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'
export default {
  name: 'student',
  components: { TopTabs },
  props: {},
  data () {
    return {
      list: []
    }
  },
  computed: {},
  watch: {},
  created () {
    this.getList()
  },
  mounted () {},
  methods: {
    async getList () {
      const { data } = await this.$get('/ow/character', { column_id: 2 })
      this.list = data
      // console.log(data)
    },
    toPage (item) {
      this.$router.push({
        path: '/xxjj/details',
        query: {
          id: item.id,
          title: '学子风采'
        }
      })
      // this.$store.commit('setSidebar', this.$nav6)
    }
  }
}
</script>

<style lang="scss" scoped>
  .szll_h5 {
     width: 100%;
     font-size: 3.7333vw;
     color: #383737;
     min-height: 86.5vh;
    .tsnn_bottom {
       display: flex;
       flex-wrap: wrap;
       padding: 0 4.2667vw;
       justify-content: space-between;
       li{
          width: 43.6vw;
          height: 28vw;
          margin-bottom: 9.3333vw;
          position: relative;
        .teacher_img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .tsnn_title {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 6.0667vw;
            line-height: 6.0667vw;
            font-size: 3.2vw;
            background:  rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 3.2vw;
         }
       }
       .no_margin {
         margin-right: 0!important;
       }
     }
  }
</style>
